import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAdditionalData, setFirstStep } from '../redux/reducer/stepReducer/stepReducer';
import { CODEMP_MUSIMUNDO } from '../utilities';

const allowedProducts = ['8', '62', '161', '159'];

const Cards = (props) => {
  const { codpro, price, plan, onNextPage, details, icono } = props;
  const [cardSelected, setCardSelected] = useState(false);
  const [isColapsadaVisible, setIsColapsadaVisible] = useState(false);
  const { codemp } = useSelector(state => state.adminReducer.login);
  const firstStep = useSelector((state) => state.firstStep.firstStep);
  const dispatch = useDispatch();

  function cardSelection() {
    setCardSelected(!cardSelected);
  }

  function toggleColapsada() {
    setCardSelected(!cardSelected);
    setIsColapsadaVisible((prevVisible) => !prevVisible);
  };

  const cardClass = cardSelected ? 'card card-selected' : 'card';

  useEffect(() => {
    if (firstStep.plan !== '') dispatch(setFirstStep({ ...firstStep, plan: '' }));
  }, []);

  useEffect(() => {
    dispatch(setAdditionalData(''));
  }, []);

  return (
    <>
      <div className={cardClass}>
        <div className="cardHeader">
          <div className={CODEMP_MUSIMUNDO.includes(codemp) ? 'badget' : 'badget-cfn'}>{icono}</div>
          <div className='planesCardInfo'>
            <h3>{plan}</h3>
            <p style={{ color: CODEMP_MUSIMUNDO.includes(codemp) ? 'red' : 'blue' }} onClick={toggleColapsada}>
              {isColapsadaVisible ? 'Menos detalles <' : 'Más detalles >'}
            </p>
          </div>
          <div className='Imgcontainer'>
            <div className={CODEMP_MUSIMUNDO.includes(codemp) ? 'bottonPrecio' : 'bottonPrecio-cfn'} onClick={() => onNextPage(2, codpro, price, plan, icono)}>${price.split(".")?.[0]}/mes</div>
          </div>
        </div>
      </div>
      {
        isColapsadaVisible && (
          <div className="cardColapsada">
            <div className='ulPlanText' style={{ padding: '6%'}} dangerouslySetInnerHTML={{ __html: details[0] }}></div>
          </div>
        )}
    </>
  );
}

export default Cards;
